var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25098,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 5.5,
    fill: "#F7FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25098,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 5.5,
    stroke: "#0070FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 10H14.8337",
    stroke: "#0070FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxbase);
export default __webpack_public_path__ + "static/media/_Checkbox base.e27b71f3c8ad17b97d001f8f13e1ad38.svg";
export { ForwardRef as ReactComponent };